import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { NAVIGATION_ROUTE } from '../../constants';
import { logout } from '../../store/slices/authSlice';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import LogoutIcon from '@mui/icons-material/Logout';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CircularProgress from '@mui/material/CircularProgress';

const pages = [
    { label: "Plans", path: NAVIGATION_ROUTE.subscription },
    { label: "Billing", path: NAVIGATION_ROUTE.billing },
    { label: "API", path: NAVIGATION_ROUTE.api },
    { label: "Change Password", path: NAVIGATION_ROUTE.changePassword },
  ];


function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const email = auth?.user?.email;
  const location = useLocation();
  const [logoutDialogOpen, setLogoutDialogOpen] = React.useState(false);
  const [logoutLoading, setLogoutLoading] = React.useState(false);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleMenuItemClick =async (setting) => {
    if (setting === 'Logout') {
        const resultAction = await dispatch(logout());
        if (logout.fulfilled.match(resultAction)) {
            navigate(NAVIGATION_ROUTE.home);
        } else {
            toast.error('Something went wrong');
        }
    }
    handleCloseUserMenu();
  };

  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
  };
  const handleLogoutConfirm = async () => {
    setLogoutLoading(true);
    // Ensure spinner is visible for at least 700ms
    setTimeout(async () => {
      setLogoutDialogOpen(false);
      const resultAction = await dispatch(logout());
      setLogoutLoading(false);
      if (logout.fulfilled.match(resultAction)) {
        navigate(NAVIGATION_ROUTE.home);
      } else {
        toast.error('Something went wrong');
      }
    }, 700);
  };
  const handleLogoutCancel = () => {
    setLogoutDialogOpen(false);
  };

  return (
    <>
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
            <Box
              component="a"
              href={NAVIGATION_ROUTE.subscription}
              sx={{
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                textDecoration: 'none',
              }}
            >
              <img 
                src="/ol_logo.png" 
                alt="Offender List Logo" 
                style={{ 
                  height: '40px', 
                  width: 'auto',
                  maxWidth: '200px'
                }} 
              />
            </Box>

            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{ display: { xs: 'block', md: 'none' } }}
                PaperProps={{
                  sx: {
                    backgroundColor: 'white',
                  }
                }}
              >
              {pages.map((page) => (
              <MenuItem
                  key={page.label}
                  component={Link}
                  to={page.path}
                  onClick={handleCloseNavMenu}
                  selected={location.pathname === page.path}
              >
                  <Typography sx={{
                    textAlign: 'center',
                    color: 'black',
                    fontWeight: location.pathname === page.path ? 700 : 400,
                    textDecoration: location.pathname === page.path ? 'underline' : 'none'
                  }}>{page.label}</Typography>
              </MenuItem>
              ))}
              </Menu>
            </Box>
            {/* <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} /> */}
            <Box
              component="a"
              href={NAVIGATION_ROUTE.subscription}
              sx={{
                mr: 2,
                display: { xs: 'flex', md: 'none' },
                flexGrow: 1,
                textDecoration: 'none',
                alignItems: 'center',
              }}
            >
              <img 
                src="/ol_logo.png" 
                alt="Offender List Logo" 
                style={{ 
                  height: '35px', 
                  width: 'auto',
                  maxWidth: '180px'
                }} 
              />
            </Box>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              {pages.map((page) => (
                <Button
                  key={page.label}
                  component={Link}
                  to={page.path}
                  onClick={handleCloseNavMenu}
                  sx={{
                    my: 2,
                    mx: 1,
                    color: 'white',
                    fontWeight: location.pathname === page.path ? 700 : 400,
                    borderBottom: location.pathname === page.path ? '2px solid #fff' : 'none',
                    borderRadius: 0,
                    display: 'block',
                    justifyContent: 'center',
                    textAlign: 'center'
                  }}
                >
                  {page.label}
                </Button>
              ))}
            </Box>
            <Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center' }}>
              {email && (
                <>
                  <Typography sx={{ color: 'white', mr: 1, fontWeight: 500, display: { xs: 'none', md: 'block' } }}>{email}</Typography>
                  <IconButton color="inherit" onClick={handleLogoutClick}>
                    <LogoutIcon />
                  </IconButton>
                </>
              )}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Dialog open={logoutDialogOpen} onClose={logoutLoading ? undefined : handleLogoutCancel} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to log out?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogoutCancel} color="primary" sx={{ borderRadius: 1, fontSize: 14 }} disabled={logoutLoading}>Cancel</Button>
          <Button onClick={handleLogoutConfirm} color="error" variant="contained" sx={{ borderRadius: 1, fontSize: 14 }} disabled={logoutLoading}>
            {logoutLoading ? <CircularProgress size={20} color="inherit" /> : 'Logout'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default ResponsiveAppBar;
